export const CELL_TYPES = {
  TITLE: 'TITLE',
  FIXED: 'FIXED',
  INPUT: 'INPUT',
  DROPDOWN: 'DROPDOWN',
};

export const DATA_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
};
